import React from 'react';
import PropTypes from 'prop-types';
import { Body, Title, Type } from '@nerdwallet/currency';
import Box from '@nerdwallet/react-box';
import classes from '@nerdwallet/base-styles/classes';

var TextScreen = function TextScreen(_ref) {
  var headline = _ref.headline,
      helperText = _ref.helperText,
      headerText = _ref.headerText;
  return /*#__PURE__*/React.createElement(Box, {
    wide: {
      columns: 8,
      noGutter: 'both',
      direction: 'column'
    },
    small: {
      columns: 4,
      direction: 'column'
    }
  }, headerText && /*#__PURE__*/React.createElement(Type, {
    size: 2,
    className: classes('margin-bottom-2')
  }, headerText), /*#__PURE__*/React.createElement(Title, {
    size: "large"
  }, headline), helperText && /*#__PURE__*/React.createElement(Body, {
    size: "small",
    className: classes('margin-top-2')
  }, helperText));
};

TextScreen.displayName = 'TextScreen';
TextScreen.propTypes = {
  /** required headline that is displayed with NDS size 4 */
  headline: PropTypes.string.isRequired,

  /** optional node that is placed below the headline */
  helperText: PropTypes.node,

  /** header text that is put above the headline */
  headerText: PropTypes.string
};
TextScreen.defaultProps = {
  helperText: null,
  headerText: null
};
export default TextScreen;